<div class="messaggio-pagina">
  <mat-icon class="messaggio-pagina__segno" aria-hidden="true">search_off</mat-icon>
  <h1>Pagina non trovata</h1>
  <p>La pagina che stai cercando non esiste. Tra qualche secondo torni alla dashboard.</p>
  <a mat-flat-button color="primary" routerLink="/">Torna alla dashboard</a>
</div>
